import React, { Component } from 'react';
import { connect }          from 'react-redux';
import { Switch, Route, withRouter } from 'react-router-dom';
import Api                  from './api/requests';

// Import components
import Header       from './containers/header';
import Footer       from './containers/footer';
import ScreenLoader from './components/common/loaders/screen';
import ScrollToTop  from './components/routing/scroll_top';

// Import containers
import Home    from './containers/home';
import Page404 from './containers/page404';
import Popups  from './popups';

// CSS
import 'modern-normalize/modern-normalize.css';
import './styles/app.scss';
import './styles/fonts.scss';

// Routing constants
import * as routes from './constants/routes';

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            initialRequestsDone: false,
            showLoader: this.props.loaderState,
            startingLoadingTime: 0,
        };
    }

    componentDidMount() {
        // Initial requests
        Api.generalDeclaration().then(() => {
            Api.getInsurancePage().then(() => {
                this.setState({ initialRequestsDone: true });
            });
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.showLoader != this.props.loaderState) {
            if (this.props.loaderState) {
                this.setState(state => {
                    return {
                        ...state,
                        showLoader: this.props.loaderState,
                        startingLoadingTime: new Date().getTime(),
                    }
                });
            } else {
                const currentTime = new Date().getTime();
                const diff = currentTime - prevState.startingLoadingTime;
                const minDelay = 2000;
                setTimeout(
                    () => this.setState({ showLoader: this.props.loaderState }),
                    diff < minDelay ? minDelay - diff : 0
                );
            }
        }
    }

    render() {
        const { location, deviceState, popupsArray } = this.props;
        const { initialRequestsDone } = this.state;

        const searchParams = new URLSearchParams(location.search);
        const isMobileApp = searchParams.has('mobileAppWebView');

        let showPopup  = popupsArray.length > 0;
        let renderPage = deviceState && initialRequestsDone;

        return (
            <div className="App">
                {renderPage && (
                    <>
                        {!isMobileApp && (
                            <Header />
                        )}

                        {/* Main routing table */}
                        <Switch>
                            {/* Regular routes */}
                            <Route exact path={routes.root}>
                                <Home isMobileApp={isMobileApp} />
                            </Route>

                            {/* Defaults to 404 if none are found */}
                            <Route component={Page404} />
                        </Switch>

                        <Footer />

                        {/* Make sure new page scroll position is at the top */}
                        <ScrollToTop />

                    </>
                )}

                {/* Main modal component */}
                {showPopup && (
                    <Popups />
                )}

                {/* Full page loader */}
                <ScreenLoader isVisible={!initialRequestsDone} />
            </div>
        );
    }
}

// Get required state from redux store and map them to the components props
const mapStateToProps = (store) => {
    return {
        deviceState: store.deviceState,
        loaderState: store.loaderState,
        popupsArray: store.popupsArray,
    };
};

export default connect(mapStateToProps, null, null, { pure: false })(
    withRouter(App)
);
